import { LocationWebshopViewModel } from "../shared/models";

export enum WebShopMode {
  Viewing = 0,
  TakeAway = 1,
  Delivery = 2,
  OrderToTable = 3,
  OrderAhead = 4,
  ExternalBasket = 5,
  Retail = 6,
  Ticket = 7,
  Webvoucher = 8,
  PickupGroup = 9,
  DeliveryGroup = 10,
}

export class ProductConfiguration {
  /** ProductDataModel ID, if exist, else null, reference to a Product in ShippingBasket */
  public id?: number;
  /** chosen extras ID and Amount thereof */
  public extras?: ProductConfigurationExtra[];
  /** Price entered by the user, i.e. WebVoucher */
  public variable_price?: number;
  /** Incase of a Ticket, the date when it will be valid */
  public valid_date?: number;
  /** How Many of this Products Should be added; Defaults to 1; */
  public count?: number;
  /** Comment for BasketItem */
  public comment?: string;
  /** Menügang */
  public menu_course?: number;
  /* Referenz auf den Buchenden Gast */
  public cus_ref_id?: number;
  public benefitData?: IBenefitCacheEntry;
  /** Reserved coupon for this product; keeps the coupon item separate from a normal item of the same product in the cart. */
  public couponData?: IReservedCoupon;
}

export class ProductConfigurationExtra {
  /** ProductExtraDataModel ID */
  public id: number;
  public count: number;
}

export class WebvoucherConfiguration {
  /** Reference zum Artikel im Warenkorb */
  public id?: number;
  /** Freieingegebener Preis. Darf nur bei Webgutscheinen mit freiem Betrag angegeben werden */
  public variable_price?: number;
  /** Anzahl der Artikel; Default ist 1; */
  public count?: number;
  /** Personen Anzahl. Wird nur angezeigt wenn übergeben; */
  public personCount?: number;
  /** Kommentar */
  public comment?: string;
  /** Zustellung per Post; */
  public postDelivery?: boolean;
  /** Zeigt die PersoenAnzahl als Extra */
  public show_person_count?: boolean;
  /** Zeigt die Versandart als Extra */
  public show_delivery?: boolean;
}

export class Webvoucher {
  public cardnumber: string;
  public balance: number;
  public balanceBonus: number;
  public get totalBalance(): number {
    return this.balance + this.balanceBonus;
  }
  public discountBonus: number;
}

export enum TrinkgeldInputMethod {
  Percentage,
  Fixed,
}

export interface IServiceTimeSelectionData {
  serviceMode: WebShopMode;
  location: LocationWebshopViewModel;
  zipCode?: string;
  city?: string;
  address?: string;
}

export interface IBenefitCacheEntry {
  readonly bonusactionId: number;
  readonly benefitId: number;
  readonly benefitProductId: number;
  readonly benefitLossId: number;
  readonly benefitCostPoints: number;
}

export interface IReservedCoupon {
  readonly couponId: number | string;
  readonly couponCode: number | string;
  readonly redemptionId?: number;
  readonly productId?: number;
}

/** Shared navigation options for WebShopService.scanCouponCode / findAndNavigateToProductByProductId / resolveAvailabilityAndNavigate. */
export interface OpenProductOptions {
  readonly backItemGroupId: number;
  /** Called before navigating to menuDetail or recipeLink, with the resolved product id. */
  readonly onBeforeOpenProduct?: (productId: number) => void;
}
